// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falItalic: CreateIconOptions = {
  "displayName": "FALItalic",
  "viewBox": "0, 0, 384, 512",
  "d": "M128 48c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-85 0L135.3 448 240 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l85 0L248.7 64 144 64c-8.8 0-16-7.2-16-16z"
};
